/**
 * 阿里云日志统计
 */

var $ = require('jquery');
var common = require('./common');
var Cookies = require('js-cookie')

$(function() {
    var clinksId = Cookies.get('clinks_id');
    var projectId = common.getQuerySearchString('projectId');
    var userId = common.getQuerySearchString('userId');
    var utmSource = common.getQuerySearchString('utm_source');
    var utmTerm = common.getQuerySearchString('utm_term');
    var utmMedium = common.getQuerySearchString('utm_medium');
    var utmContent = common.getQuerySearchString('utm_content');
    var utmCampaign = common.getQuerySearchString('utm_campaign');
    var cityCode = Cookies.get("user_region_code");
    var check_project_link = /\/project\/detail\/([\d]+)/;
    var url_pathname = window.location.pathname;

    if(!projectId && check_project_link.test(url_pathname)){
        userId = Cookies.get('project_detail_userId')
        projectId  = url_pathname.substring(url_pathname.lastIndexOf("\/") + 1, url_pathname .length);
    }
    clinksId = clinksId ? clinksId : '';
    projectId = projectId ? projectId : '';
    utmSource = utmSource ? utmSource : '';
    utmTerm = utmTerm ? utmTerm : '';
    utmMedium = utmMedium ? utmMedium : '';
    utmContent = utmContent ? utmContent : '';
    utmCampaign = utmCampaign ? utmCampaign : '';
    cityCode = cityCode ? cityCode : '';

    var logger = new window.Tracker('cn-shanghai.log.aliyuncs.com','toodc','site');
    var params = {
        'clinksId': clinksId,
        'projectId': projectId,
        'userId': userId,
        'utm_source':utmSource,
        'utm_term':utmTerm,
        'siteSource': 'pc',
        'actionType': 'pv',
        'umm': utmMedium,
        'uct': utmContent,
        'ucn': utmCampaign,
        'cc' : cityCode
    };

    for(var key in params){
        logger.push(key,params[key]);
    }

    //调用系统提供的收集函数
    window.Agent(logger);
    //发送日志数据
    logger.logger();

    $(document).on('click','[data-middle-type]',function() {
        var $this = $(this);
        var elementId = $this.data('middle-type');
        var projectId = $this.data('projectId');

        let click = $this.data('click');
        if (click && click !== '') {
            elementId = click;
        }

        var params = {
            'clinksId': clinksId,
            'projectId': projectId,
            'siteSource': 'pc',
            'actionType': 'click',
            'elementId': elementId,
            'umm': utmMedium,
            'uct': utmContent,
            'ucn': utmCampaign,
            'cc' : cityCode
        };

        for(var key in params){
            logger.push(key,params[key]);
        }

        //调用系统提供的收集函数
        window.Agent(logger);
        //发送日志数据
        logger.logger();
    });
});



//////////////////
// WEBPACK FOOTER
// ./src/global/js/web-tracking.js
// module id = 14
// module chunks = 0 1 2 3